<template>

  <div class="share-product">
    <div class="header">{{ capitalize('Share Product') }}</div>

    <section class="share-options">
      <section class="option email">
        <div class="header" v-on:click="isEmailShareOpen = !isEmailShareOpen">
          EMAIL
          <i v-show="!isEmailShareOpen" class="fa fa-angle-down"></i>
          <i v-show="isEmailShareOpen" class="fa fa-angle-up"></i>
        </div>
        <div v-show="isEmailShareOpen" class="content">
          <input v-model="emailAddress" v-on:keyup.enter="sendEmailShare" placeholder="Enter email address" class="sleek-input email">
          <span v-bind:class="{ inactive: !isEmailValid }" v-on:click="sendEmailShare" class="sleek-button">
            <span v-if="!emailIsSending">{{ capitalize("Send") }}</span>
            <LoadingSpinner v-else></LoadingSpinner>
          </span>
        </div>
      </section>
      <section class="option sms">
        <div class="header" v-on:click="isSmsShareOpen = !isSmsShareOpen">
          SMS
          <i v-if="!isSmsShareOpen" class="fa fa-angle-down"></i>
          <i v-else class="fa fa-angle-up"></i>
        </div>
        <div v-if="isSmsShareOpen" class="content">
          <PhoneNumber
            v-bind:onEnterClick="sendSmsShare"
            v-bind:setPhoneNumberValid="() => isPhoneNumberValid = true"
            v-bind:setPhoneNumberInvalid="() => isPhoneNumberValid = false"
            ref="phone-number-component">
          </PhoneNumber>
          <span v-bind:class="{ inactive: !isPhoneNumberValid }" v-on:click="sendSmsShare" class="sleek-button">
            <span v-if="!smsIsSending">{{ capitalize("Send") }}</span>
            <LoadingSpinner v-else></LoadingSpinner>
          </span>
        </div>
      </section>
      <section class="option url">
        <div class="header" v-on:click="onLinkShareClick()">
          LINK
          <i v-if="!isUrlShareOpen" class="fa fa-angle-down"></i>
          <i v-else class="fa fa-angle-up"></i>
        </div>
        <div v-if="isUrlShareOpen" class="content url-share">
          <button v-on:click="copyShareLink()" class="sleek-button copy-link">
            <span v-if="!isLinkLoading">{{ capitalize("Copy Link") }}</span>
            <LoadingSpinner v-else></LoadingSpinner>
          </button>
        </div>
      </section>
    </section>
  </div>

</template>

<script>


import { mapGetters } from 'vuex'
import EventBus from '@/components/utilities/EventBus'
import LoadingSpinner from '@/components/utilities/LoadingSpinner'
import PhoneNumber from '@/components/form/PhoneNumber'
import formHelper from '@/helpers/formHelper'
import stringHelper from '@/helpers/stringHelper'

export default {
  name: 'ShareProduct',
  props: {
    modalProps: {
      type: Object,
      default: () => { return {} }
    }
  },
  components: {
    LoadingSpinner,
    PhoneNumber
  },
  data () {
    return {
      isEmailShareOpen:     false,
      isSmsShareOpen:       false,
      isUrlShareOpen:       false,
      emailAddress:         '',
      emailIsSending:       false,
      smsIsSending:         false,
      isPhoneNumberValid:   false,
      isLinkLoading:        false,
      shareLink:            ''
    }
  },
  computed: {
    ...mapGetters(['currentUser']),
    isEmailValid () {
      return formHelper.validateEmail(this.emailAddress)
    }
  },
  methods: {
    onLinkShareClick () {
      this.isUrlShareOpen = !this.isUrlShareOpen
      if (this.isUrlShareOpen) this.initiateLinkShare()
    },
    sendEmailShare () {
      if (this.emailIsSending) return
      this.emailIsSending = true
      this.createProductLinkForUser(this.onProductCreateEmail)
    },
    onProductCreateEmail (productLink) {
      this.axios.post('users/' + this.currentUser.id + '/product_links/' + productLink.id + '/shares/email', { email_address: this.emailAddress })
        .then((response) => this.onEmailSent(response.data))
    },
    sendSmsShare () {
      if (this.smsIsSending) return
      this.smsIsSending = true
      this.createProductLinkForUser(this.onProductCreateSms)
    },
    onProductCreateSms (productLink) {
      let phoneNumber = this.$refs['phone-number-component'].fullPhoneNumber
      this.axios.post('users/' + this.currentUser.id + '/product_links/' + productLink.id + '/shares/sms', { phone_number: phoneNumber })
        .then((response) => this.onSmsSent(response.data))
    },
    createProductLinkForUser (callback) {
      this.axios.post('users/' + this.currentUser.id + '/product_links', { product_link: stringHelper.unCamelizeObject(this.modalProps.productLink) })
        .then((response) => { callback(stringHelper.camelizeObject(response.data.product_link)) })
    },
    initiateLinkShare () {
      // First, we need to make sure that the current user is associated with this product.
      // Make a POST request to either create or fetch the product for this user, and then create the share link.
      if (this.isLinkLoading) return

      this.isLinkLoading  = true
      this.shareLink      = ''
      this.createProductLinkForUser(this.createShareLink)
    },
    createShareLink (productLink) {
      this.axios.post('users/' + this.currentUser.id + '/product_links/' + productLink.id + '/shares/url')
        .then((response) => { this.onShareLinkCreated(response.data) })
    },
    onEmailSent (data) {
      EventBus.$emit('drop', {
        message:    'Product successfully sent to: ' + this.emailAddress,
        statusCode: 1
      })

      this.emailAddress     = ''
      this.isEmailShareOpen = false
      this.emailIsSending   = false
    },
    onSmsSent (data) {
      EventBus.$emit('drop', {
        message:    'Product successfully sent to: ' + this.$refs['phone-number-component'].fullPhoneNumber,
        statusCode: 1
      })

      this.$refs['phone-number-component'].clearPhoneNumber()
      this.smsIsSending   = false
      this.isSmsShareOpen = false
    },
    onShareLinkCreated (data) {
      this.shareLink      = data.share_link
      this.isLinkLoading  = false
    },
    copyShareLink () {
      this.$copyText(this.shareLink)          // This uses VueClipboard
      EventBus.$emit('drop', {
        message:      'Link copied to clipboard!',
        statusCode:   1
      })
      this.isUrlShareOpen = false
    },
    // EXTERNAL METHOD
    modalCloseCallback () {
      this.isUrlShareOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>

.share-product {

  > .header {
    font-size:                  1.5em;
    text-align:                 center;
  }

  .share-options {
    margin-top:                 1em;

    .option {
      border:                   1px solid black;

      &:last-of-type {

        .header {
          border-bottom:        none;
        }
      }

      .header {
        display:                flex;
        cursor:                 pointer;
        padding:                0.5em;
        color:                  white;
        background-color:       black;
        border-bottom:          1px solid white;

        > i {
          margin-left:          auto;
          font-size:            1.5em;
        }
      }

      .content {
        padding:                0.5em;
        display:                flex;
        margin:                 1em 0;

        .sleek-input {
          width:                50%;
          border-radius:        0;
        }

        .sleek-button {
          font-size:            1em;
          padding:              0.25em;
          width:                9em;
          text-align:           center;
          display:              inline-block;
          margin-left:          auto;

          > span {
            vertical-align:     middle;
          }
        }

        &.url-share {

          .sleek-button {
            border:             none;
            margin:             0 auto;
          }
        }
      }
    }
  }

}

/* Portrait tablet to landscape and desktop */
@media (max-width: 768px) {

  .share-product {

  }
}


/* Mobile */
@media (max-width: 480px) {

  .share-product {

    .share-options {

      .option {

        .content {

          .sleek-input {
            width:                65%;
          }

          .sleek-button {
            width:                4em;

            &.copy-link {
              width:              8em;
            }
          }
        }
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/share/ShareProduct.vue